



import { useRef } from 'react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { InputGroup } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { FaSearch, FaUserPlus, FaEdit, FaTrash ,FaPlus,FaMoneyCheckAlt } from 'react-icons/fa';
import writtenNumber from 'written-number';

const numberToWords = (n) => {
  const unite = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];
  const dizaine = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];
  const dizaine10 = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];


  const entierToWords = (num) => {
    if (num === 0) return 'zéro';
    let result = '';
    
    if (num >= 1000000) {
      const millions = Math.floor(num / 1000000);
      result += `${entierToWords(millions)} million${millions > 1 ? 's' : ''} `;
      num %= 1000000;
    }
    
    if (num >= 1000) {
      const milliers = Math.floor(num / 1000);
      result += `${milliers === 1 ? '' : entierToWords(milliers)} mille `;
      num %= 1000;
    }
    
    if (num >= 100) {
      const centaines = Math.floor(num / 100);
      result += `${centaines === 1 ? 'cent' : unite[centaines] + ' cent'} `;
      num %= 100;
      if (num === 0 && centaines > 1) result += 's ';
    }
    
    if (num >= 20) {
      const dz = Math.floor(num / 10);
      const u = num % 10;
      if (dz === 7 || dz === 9) {
        result += dizaine[dz - 1] + '-' + dizaine10[u];
      } else {
        result += dizaine[dz];
        if (u === 1 && dz !== 8) result += ' et un';
        else if (u > 0) result += '-' + unite[u];
      }
    } else if (num >= 10) {
      result += dizaine10[num - 10];
    } else if (num > 0) {
      result += unite[num];
    }
    
    return result.trim();
  };


  const decimalToWords = (decStr) => {
    return decStr
      .split('')
      .map(d => unite[parseInt(d)])
      .join(' ');
  };


  if (typeof n === 'string' && (n.includes(',') || n.includes('.'))) {
    let parts = n.includes(',') ? n.split(',') : n.split('.');
    let partieEntiere = parseInt(parts[0]);
    let partieDecimale = parts[1];

    return `${entierToWords(partieEntiere)} virgule ${decimalToWords(partieDecimale)}`;
  }

  return entierToWords(Number(n));
};





writtenNumber.defaults.lang = 'fr';
const ChequeForm = () => {
  const [cheques, setCheques] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedCheque, setSelectedCheque] = useState(null);
  const [positions, setPositions] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
const chequeRef = useRef();
  const [formData, setFormData] = useState({
    montant: '',
    order_a: '',
    fait_a: '',
    date: new Date().toISOString().split('T')[0],
    position_id: '',
    client_id: '',
    type: 'normal'
  });

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchCheques();
    fetchPositions();
    fetchClients();
  }, []);

 const fetchCheques = async () => {
  setIsLoading(true);
  setError(null);
  try {
    const response = await axios.get('https://gce.iasoft.ma/api/cheques', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setCheques(response.data);
  } catch (err) {
    setError('Erreur lors du chargement des chèques');
    console.error('Erreur:', err);
  } finally {
    setIsLoading(false);
  }
};


const fetchPositions = async () => {
  try {
    const response = await axios.get('https://gce.iasoft.ma/api/positions', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setPositions(response.data);
  } catch (err) {
    setError('Erreur lors du chargement des positions');
    console.error('Erreur:', err);
  }
};

const fetchClients = async () => {
  try {
    const response = await axios.get('https://gce.iasoft.ma/api/clients', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setClients(response.data);
  } catch (err) {
    setError('Erreur lors du chargement des clients');
    console.error('Erreur:', err);
  }
};


  const handleAddChequeClick = () => {
    setFormData({
      position_id: '',
      montant: '',
      order_a: '',
      fait_a: '',
      date: new Date().toISOString().split('T')[0],
      client_id: '',
      type: 'normal'
    });
    setSelectedCheque(null);
    setShowModal(true);
  };

  const handleEditClick = (cheque) => {
    setSelectedCheque(cheque);
    setFormData({
      ...cheque,
      position_id: cheque.position_id || '',
      client_id: cheque.client_id || '',
      type: cheque.type || 'normal'
    });
    setShowModal(true);
  };

 




  const handleSubmit = async () => {
  setIsLoading(true);
  setError(null);
  try {
    if (selectedCheque) {
      await axios.put(`https://gce.iasoft.ma/api/cheques/${selectedCheque.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } else {
      await axios.post('https://gce.iasoft.ma/api/cheques', formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
    fetchCheques();
    setShowModal(false);
  } catch (err) {
    setError('Erreur lors de la soumission');
    console.error('Erreur:', err);
  } finally {
    setIsLoading(false);
  }
};

const handleDelete = async (id) => {
  if (window.confirm('Voulez-vous vraiment supprimer ce chèque ?')) {
    setIsLoading(true);
    setError(null);
    try {
      await axios.delete(`https://gce.iasoft.ma/api/cheques/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchCheques();
    } catch (err) {
      setError('Erreur lors de la suppression');
      console.error('Erreur:', err);
    } finally {
      setIsLoading(false);
    }
  }
};


  const handleTypeChange = (chequeId, value) => {
    setSelectedTypes((prev) => ({ ...prev, [chequeId]: value }));
  };


  const convertStyle = (styleJson) => {
  try {
    const obj = typeof styleJson === 'string' ? JSON.parse(styleJson) : styleJson;
    return Object.entries(obj).map(([key, value]) => `${key}:${value}`).join('; ');
  } catch (e) {
    console.error('Erreur dans le style JSON :', styleJson, e);
    return '';
  }
};



function montantLettre(montant, devise = 'dirham') {

  const devises = {
    dirham: ['dirham', 'dirhams'],
    euro: ['euro', 'euros'],
    dollar: ['dollar', 'dollars'],
  };

  const montantStr = montant.toString().replace(',', '.');
  const [entierStr, decimalStr] = montantStr.split('.');

  const entier = parseInt(entierStr, 10);
  const decimal = decimalStr ? parseInt(decimalStr.padEnd(2, '0').slice(0, 2), 10) : 0;


  const [singulier, pluriel] = devises[devise.toLowerCase()] || ['unité', 'unités'];

  let resultat = writtenNumber(entier) + (entier > 1 ? ` ${pluriel}` : ` ${singulier}`);

  if (decimal > 0) {
    resultat += ' et ' + writtenNumber(decimal) + (decimal > 1 ? ' centimes' : ' centime');
  }

  return resultat;
}


const handlePrint = (cheque) => {
  const printWindow = window.open('', '_blank');
  const montantLettre = numberToWords(cheque.montant);

  // Récupérer les positions depuis la base de données
  const position = cheque.position;

  if (!position) {
    alert("Aucune position associée à ce chèque.");
    return;
  }

  // Fonction pour parser et formater les styles
  const parseStyle = (styleObj) => {
    if (!styleObj) return {};

    try {
      if (typeof styleObj === 'object') return styleObj;
      return JSON.parse(styleObj);
    } catch (e) {
      console.error("Erreur de parsing du style:", e);
      return {};
    }
  };

  // Fonction pour convertir le style en CSS avec rotation
  const styleToCss = (style) => {
    if (!style) return '';

    const css = {
      position: 'absolute',
      left: `${style.x || 0}px`,
      top: `${style.y || 0}px`,
      width: style.width ? `${style.width}px` : 'auto',
      height: style.height ? `${style.height}px` : 'auto',
      'font-family': 'Arial, sans-serif',
      'font-size': style.fontSize ? `${style.fontSize}px` : '0px',
      'font-weight': style.fontWeight || 'normal',
    };

    return Object.entries(css).map(([key, value]) => `${key}: ${value}`).join('; ');
  };

  // Formater le montant en lettres
  const formatMontantLettre = (style, text) => {
    const parsedStyle = parseStyle(style);
    const css = styleToCss(parsedStyle);

    return `
      <div style="${css}">
        ${text}
      </div>
    `;
  };
// URL de l'image de chèque
const chequeImageUrl = position.image
  ? `https://gce.iasoft.ma/images/${position.image}`
  : '/blank_cheque.png';

  // Type de chèque et image correspondante
  const typeImages = {
    'barré': '/barre.png',
    'non_endossable': '/NE.png',
    'non_endossable_plus': '/BARRENE.png'
  };
  const typeImageUrl = typeImages[cheque.type] || '';

  printWindow.document.write(`
    <html>
      <head>
        <title>Chèque ${cheque.id}</title>
        <style>
          @page {
            size: A4;
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            width: 210mm;
            height: 297mm;
            position: relative;
            background-color: white;
          }
          .cheque-container {
            position: relative;
            width: 100%;
            height: 100%;
          }

          .cheque-field {
            position: absolute;
            z-index: 1;
            background-color: transparent;
          }
          .montant-lettres {
            white-space: pre-wrap;
          }
          .no-print {
            display: none;
          }
          @media print {
            body {
              width: 210mm;
              height: 297mm;
              overflow: hidden;
            }
            .no-print {
              display: none !important;
            }
          }
        </style>
      </head>
      <body>
        <div class="cheque-container">
          <!-- Image de fond du chèque -->
        
          <!-- Montant numérique -->
          <div class="cheque-field" style="${styleToCss(parseStyle(position.positionsMontant))}">
            ${cheque.montant}
          </div>

          <!-- Montant en lettres -->
          ${formatMontantLettre(position.positionsMontantLettre, montantLettre)}

          <!-- Ordre à -->
          <div class="cheque-field" style="${styleToCss(parseStyle(position.positionorder_a))}">
            ${cheque.order_a}
          </div>

          <!-- Fait à -->
          <div class="cheque-field" style="${styleToCss(parseStyle(position.positionfait_a))}">
            ${cheque.fait_a}
          </div>

          <!-- Date -->
          <div class="cheque-field" style="${styleToCss(parseStyle(position.positionDate))}">
            ${cheque.date.split('-').reverse().join('/')}
          </div>

          <!-- Type de chèque -->
          ${typeImageUrl ? `
            <div class="cheque-field" style="${styleToCss(parseStyle(position.positionType))}">
              <img src="${typeImageUrl}" style="width: 100px; height: auto;" />
            </div>
          ` : ''}

          <!-- Bouton d'impression (visible seulement à l'écran) -->
          <button class="no-print" onclick="window.print();" style="
            position: fixed;
            top: 20px;
            right: 20px;
            padding: 10px 15px;
            background: #2c3e50;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            z-index: 100;
          ">
            Imprimer
          </button>
        </div>
        <script>
          // Auto-print when window loads
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};



  return (
    <div >
   

      {error && (
        <div className="error-alert alert alert-danger alert-dismissible fade show">
          {error}
          <button type="button" className="close" onClick={() => setError(null)}>
            <span>&times;</span>
          </button>
        </div>
      )}
<br></br>
<div className="cheque" >

  <div className="header-section">
        <h2 className="page-title">
          <FaMoneyCheckAlt /> Gestion des Chèques
        </h2>
       </div>

<br></br>


          <div className="header-section">
                      <div className="action-buttons d-flex align-items-center">
                          <Button className="btn-custom-primary" onClick={handleAddChequeClick}>
                            <FaPlus className="me-1" />
                              Ajouter
                          </Button>
                      </div>
                  </div>
<br></br>
    <div className="search-section mb-4">
  <InputGroup>
    <InputGroup.Text>
      <FaSearch />
    </InputGroup.Text>
    <Form.Control
      type="search"
      placeholder="Rechercher par montant..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </InputGroup>
</div>



     

        {isLoading ? (
          <div className="text-center py-5">
            <div className="loading-spinner text-primary"></div>
            <p className="mt-2">Chargement en cours...</p>
          </div>
        ) : (
          <Table striped bordered hover className="cheque-table">
            <thead>
              <tr> 
                <th>Actions</th>
                <th>Montant</th>
                <th>Ordre À</th>
                <th>Date</th>
                <th>Montant lettre</th>
                <th>Banque</th>
                <th>type </th>
                <th>Genre</th>
                
               
              </tr>
            </thead>
            <tbody>
              {cheques
                .filter((c) => c.montant.toString().includes(search))
                .map((chq) => (
                  <tr key={chq.id}>  
                    <td>
                      <div className="action-buttons d-flex flex-wrap">
                     
                    





  
                                        <Button
                                            variant="outline-warning"
                                            size="sm"
                                              onClick={() => handleEditClick(chq)}
                                            className="me-2"
                                        >
                                            <FaEdit />
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                             onClick={() => handleDelete(chq.id)}
                                                  className="me-2"
                                        >
                                            <FaTrash />
                                        </Button>
                         







                        
                        <Button 
                          variant="outline-info" 
                          size="sm" 
                          onClick={() => handlePrint(chq)}
                              className="me-2"
                        >
                          <i className="fas fa-print"></i>
                        </Button>
                      
                      </div>
                    </td>
                    <td>{chq.montant} DH</td>
                    <td>{chq.order_a}</td>
                    <td>{new Date(chq.date).toLocaleDateString()}</td>
                <td>{montantLettre(chq.montant)} </td>

  <td>{chq.position?.nombanque || 'Non spécifié'}</td>
  <td>{chq.position?.piece || 'Non spécifié'}</td>
                <td>{chq.type}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
      </div>


<Modal show={showModal} onHide={() => setShowModal(false)} centered className="cheque-modal" size="lg">
  <Modal.Header closeButton className="modal-header-custom">
    <Modal.Title className="modal-title-custom">
      {selectedCheque ? 'Modifier le chèque' : 'Ajouter un chèque'}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="modal-body-custom">
    <Form>
      <Row>
        <Col md={6}>
 
<Form.Group className="mb-4 form-group-custom">
  <Form.Label className="form-label-custom">Banque</Form.Label>
  <Select
    className="react-select-container"
    classNamePrefix="react-select"
    options={positions.map(position => ({
      value: position.id,
      label: position.nombanque
    }))}
    value={
      positions.find(p => p.id === formData.position_id)
        ? {
            value: formData.position_id,
            label: positions.find(p => p.id === formData.position_id).nombanque
          }
        : null
    }
    onChange={(option) =>
      setFormData({
        ...formData,
        position_id: option?.value || ''
      })
    }
    placeholder="Sélectionner une banque"
    isClearable
    isSearchable // ✅ Permet la recherche dynamique
    noOptionsMessage={() => 'Aucune banque trouvée'}
    styles={{
      control: (provided) => ({
        ...provided,
        height: '40px',
        minHeight: '40px',
        borderRadius: '8px',
        borderColor: '#ced4da',
        '&:hover': {
          borderColor: '#80bdff',
        }
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0 8px'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }}
  />
</Form.Group>


       
          <Form.Group className="mb-4 form-group-custom">
            <Form.Label className="form-label-custom">Montant (DH)</Form.Label>
            <div className="amount-container">
              <Form.Control
                className="form-control-custom amount-input"
                type="number"
                value={formData.montant}
                onChange={(e) => setFormData({ ...formData, montant: e.target.value })}
                required
              />
              <span className="currency-symbol">DH</span>
            </div>
          </Form.Group>

         
          <Form.Group className="mb-4 form-group-custom">
            <Form.Label className="form-label-custom">Type de chèque</Form.Label>
            <Form.Select
              className="form-control-custom"
              value={formData.type || 'normal'}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            >
              <option value="normal">Normal</option>
              <option value="barré">Barré (//)</option>
              <option value="non_endossable">Non Endossable</option>
              <option value="non_endossable_plus">Non Endossable + //</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          
       <Form.Group className="mb-4 form-group-custom">
  <Form.Label className="form-label-custom">Tiers (Ordre À)</Form.Label>
  <Select
    className="react-select-container"
    classNamePrefix="react-select"
    options={clients
      .sort((a, b) => a.nom.localeCompare(b.nom))
      .map(client => ({
        value: client.id,
        label: client.nom
      }))}
    value={
      formData.client_id
        ? {
            value: formData.client_id,
            label: clients.find(c => c.id === formData.client_id)?.nom
          }
        : null
    }
    onChange={(option) =>
      setFormData({
        ...formData,
        client_id: option?.value || '',
        order_a: option?.label || ''
      })
    }
    placeholder="Sélectionner un client"
    isClearable
    isSearchable // ✅ Activation de la recherche (par défaut true)
    noOptionsMessage={() => "Aucun client trouvé"} // Message personnalisé si aucun résultat
  />
</Form.Group>


       
          <Form.Group className="mb-4 form-group-custom">
            <Form.Label className="form-label-custom">Fait À</Form.Label>
            <Form.Control
              className="form-control-custom"
              type="text"
              value={formData.fait_a}
              onChange={(e) => setFormData({ ...formData, fait_a: e.target.value })}
              required
            />
          </Form.Group>

         
          <Form.Group className="mb-4 form-group-custom">
            <Form.Label className="form-label-custom">Date</Form.Label>
            <Form.Control
              className="form-control-custom"
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  </Modal.Body>

  <Modal.Footer className="modal-footer-custom">
    <Button
      variant="primary"
      onClick={handleSubmit}
      disabled={isLoading}
      className="btn-save-custom"
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2"></span>
          Enregistrement...
        </>
      ) : (
        <>
          <i className="fas fa-save me-2"></i> Enregistrer
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>

<style>{`




     .btn-custom-primary {
          background-color: #2c3e50;
          border-color: #2c3e50;
          color: white;
          border-radius: 0.25rem;
          padding: 0.5rem 1rem;
        }

        .btn-custom-primary:hover,
        .btn-custom-primary:focus {
          background-color: #1a242f;
          border-color: #1a242f;
          color: white;
        }
 .cheque {
       min-height: 80vh;
                    width:70%;
                    margin-right:80%;


          }
          
          .action-buttons .btn {
            margin-right: 5px;
            margin-bottom: 5px;
          }
          
          .cheque-table {
            background-color: white;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }
          
          .cheque-table th {
            background-color:rgb(255, 255, 255);
            color: black;
            font-weight: 500;
          }
          
          .cheque-table tr:hover {
            background-color: rgba(0,0,0,0.03);
          }
          
          .search-box {
            max-width: 300px;
            border-radius: 20px;
            padding-left: 15px;
            border: 1px solid #ced4da;
          }
            .search-section {
                    max-width: 500px;
                }
          .add-btn {
            background-color: #1a242f;
            border-color: #1a242f;
            border-radius: 20px;
            padding: 5px 20px;
            font-weight: 500;
            transition: all 0.3s;
          }
          
          .add-btn:hover {
            background-color: #1a242f;
            border-color: #1a242f;
            transform: translateY(-1px);
          }
          
          .modal-header {
            background-color: #343a40;
            color: white;
          }
          
          .type-selector {
            width: 180px;
            display: inline-block;
            margin-left: 10px;
          }
          
          .btn-print {
            background-color: #17a2b8;
            border-color: #17a2b8;
          }
          
          .btn-print:hover {
            background-color: #138496;
            border-color: #117a8b;
          }
          
          .loading-spinner {
            display: inline-block;
            width: 1.5rem;
            height: 1.5rem;
            vertical-align: text-bottom;
            border: 0.25em solid currentColor;
            border-right-color: transparent;
            border-radius: 50%;
            animation: spinner-border 0.75s linear infinite;
          }
          
          @keyframes spinner-border {
            to { transform: rotate(360deg); }
          }
          
          .error-alert {
            position: fixed;
            top: 20px;
            right: 20px;
            z-index: 1050;
            min-width: 300px;
          }

              .page-title {
                    color: #2c3e50;
                    font-weight: 600;
                    margin: 0;
                }
  .cheque-modal .modal-content {
    border-radius: 0;
    font-family: 'Times New Roman', serif;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }

  .modal-header-custom {
    background-color: #1a3e72;
    color: white;
    border-bottom: 2px solid #0a244a;
    padding: 15px;
  }

  .modal-title-custom {
    font-weight: bold;
    font-size: 1.3rem;
    text-align: center;
    width: 100%;
  }

  .modal-body-custom {
    background-color: #f8f9fa;
    padding: 20px;
  }

  .form-label-custom {
    font-weight: bold;
    color: #1a3e72;
    display: block;
    margin-bottom: 5px;
  }

  .form-group-custom {
    margin-bottom: 20px;
  }

  .form-control-custom {
    border: 1px solid #ccc;
    border-radius: 0;
    padding: 8px;
    width: 100%;
    font-family: 'Times New Roman', serif;
  }

  .form-control-custom:focus {
    border-color: #1a3e72;
    box-shadow: 0 0 0 0.2rem rgba(26, 62, 114, 0.25);
  }

  .react-select__control {
    border: 1px solid #ccc !important;
    border-radius: 0 !important;
    min-height: 38px !important;
  }

  .react-select__control--is-focused {
    border-color: #1a3e72 !important;
    box-shadow: 0 0 0 0.2rem rgba(26, 62, 114, 0.25) !important;
  }

  .amount-container {
    position: relative;
  }

  .amount-input {
    padding-right: 30px;
  }

  .currency-symbol {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #555;
  }

  .btn-save-custom {
    background-color: #1a3e72;
    border: none;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 0;
    margin-right:40%;
  }

  .btn-save-custom:hover {
    background-color: #0a244a;
  }

  .btn-save-custom:disabled {
    background-color: #6c757d;
  }
`}</style>

    
    </div>
  );
};

export default ChequeForm;

